<template>
  <l-layout>
    <v-card>
      <v-card-title style="height: 96px">
        <v-layout>
          <v-layout column>
            <v-flex class="pb-3" layout align-center>
              <span class="pl-2"></span>
              <span
                :style="{cursor: 'pointer'}"
                class="subheading primary--text"
                @click="goList"
              >违章事件列表</span>
              <v-progress-circular
                v-if="parentLoading"
                size="16" width="2"
                class="mx-2"
                indeterminate
                color="grey"
              ></v-progress-circular>
              <v-icon v-else class="mx-2">$vuetify.icons.chevronRight</v-icon>
              <template v-for="(item, i) in bcItems">
          <span
            :class="'primary--text'"
            :key="i"
            :style="{cursor: 'pointer'}"
            class="subheading"
            @click="goDetails(item)"
          >{{item.name}}</span>
                <v-icon :key="i + 'divider'" class="mx-2">$vuetify.icons.chevronRight</v-icon>
              </template>
            </v-flex>
            <v-flex>
              <span v-if="!rule.name" class="title pl-2 grey--text">规则名称</span>
              <span v-else class="title pl-2">{{rule.name}}</span>
            </v-flex>
          </v-layout>
          <v-spacer></v-spacer>
          <slot name="title-actions"></slot>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-container class="pt-0" grid-list-md>
          <v-form>
            <!--<v-subheader>基本信息</v-subheader>-->
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  :disabled="isReadonly"
                  :placeholder="isReadonly ? 'N/A': ''"
                  label="规则名称"
                  prepend-icon="$vuetify.icons.title"
                  v-model="rule.name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :disabled="isReadonly"
                  :placeholder="isReadonly ? 'N/A': ''"
                  label="规则描述"
                  prepend-icon="$vuetify.icons.description"
                  v-model="rule.description"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field
                  :placeholder="isReadonly ? 'N/A': ''"
                  :disabled="!isRoot || isReadonly"
                  label="最大违章次数"
                  prepend-icon="$vuetify.icons.timer"
                  v-model="ruleMax"
                  type="number"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field
                  :placeholder="isReadonly ? 'N/A': ''"
                  :disabled="!isRoot || isReadonly"
                  label="严重程度"
                  prepend-icon="$vuetify.icons.severity"
                  v-model="ruleSeverity"
                  type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <template v-if="isRoot">
              <v-subheader>关联分组</v-subheader>
              <v-layout>
                <v-flex>
                  <v-select
                    :items="groups"
                    chips
                    :disabled="isReadonly"
                    :placeholder="isReadonly ? 'N/A': ''"
                    deletable-chips
                    item-text="name"
                    item-value="id"
                    label="关联分组"
                    multiple
                    no-data-text="没有可选分组"
                    prepend-icon="$vuetify.icons.group"
                    v-model="bindGroup"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-subheader>绑定模板</v-subheader>
              <!--暂时不区分类型-->
              <v-tabs v-model="typeTab" v-show="false">
                <v-tab :key="type.key" v-for="(type) in typeDefines">{{type.name}}</v-tab>
              </v-tabs>
              <v-divider></v-divider>
              <v-tabs-items v-model="typeTab">
                <v-tab-item :key="type.key" v-for="(type) in typeDefines">
                  <v-list v-if="bindGroup.length === 0">
                    <v-list-tile>
                      <v-list-tile-title
                        class="grey--text text-xs-center"
                      >{{isReadonly ? '未绑定分组':'请先绑定分组'}}
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                  <template
                    v-for="(g, index) in rule.templates[type.key]"
                  >
                    <v-subheader :key="index + 'd'">
                      <v-icon small class="pr-2">$vuetify.icons.group</v-icon>
                      {{g.name}}
                    </v-subheader>
                    <v-expansion-panel
                      :key="index"
                      expand style="box-shadow: none !important;" class="pa-0">
                      <v-expansion-panel-content
                        class="pa-0"
                        hide-actions
                        v-for="i in Number(rule.max)"
                        :key="i"
                      >
                        <v-layout align-center class="pa-0 ma-0" two-line slot="header">

                          <!--                          <v-flex shrink class="pr-4">-->
                          <!--                            <v-icon>$vuetify.icons.group</v-icon>-->
                          <!--                          </v-flex>-->
                          <v-flex>
                            <span class="mr-4 subheading">第{{i}}次违章</span>
                            <span class="grey--text body-2">
                              {{g.templates[i-1] && (g.templates[i-1].name || g.templates[i-1].id ||'未配置')}}
                            </span>
                          </v-flex>
                          <v-spacer></v-spacer>
                          <v-flex v-if="!isReadonly" shrink @click.stop class="pr-2">
                            <v-tooltip left v-if="!hasTemplate(g.templates[i-1])">
                              <v-btn class="ma-0" @click="openSelectTemplateDialog(type.key, g.templates, i-1)" icon
                                     slot="activator">
                                <v-icon>$vuetify.icons.add</v-icon>
                              </v-btn>
                              <span>添加模板</span>
                            </v-tooltip>
                            <v-tooltip left v-else>
                              <v-btn class="ma-0" @click="deleteTemplate(g.templates, i - 1)" icon slot="activator">
                                <v-icon>$vuetify.icons.close</v-icon>
                              </v-btn>
                              <span>删除模板</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                        <v-container grid-list-md fluid class="pl-4 pr-3 py-0">
                          <v-layout>
                            <p class="px-2">
                              {{g.templates[i-1] && g.templates[i-1].text}}
                            </p>
                          </v-layout>
                          <v-layout wrap>
                            <template v-for="(value, j) in (g.templates[i-1] ? g.templates[i-1].variantList : [])">
                              <v-flex xs4 :key="j + 'name'">
                                <v-text-field
                                  :disabled="isReadonly"
                                  class="pl-3"
                                  label="变量名"
                                  persistent-hint
                                  hint="填入模板中的{i}，覆盖指定变量"
                                  v-model="value.key"
                                  :rules="[v => /\{\d+\}/.test(v) || '变量格式错误']"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs8 :key="j + 'value'" layout align-center>
                                <v-flex>
                                  <v-text-field
                                    :disabled="isReadonly"
                                    class="ma-0"
                                    label="变量内容"
                                    v-model="value.value"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex shrink v-if="!isReadonly">
                                  <v-btn @click="deleteVar(g.templates[i-1].variantList, j)" icon>
                                    <v-icon>$vuetify.icons.clear</v-icon>
                                  </v-btn>
                                </v-flex>
                              </v-flex>
                            </template>
                            <v-flex xs12>
                              <v-btn
                                @click="addVar(g.templates[i-1])"
                                :disabled="!hasTemplate(g.templates[i-1])"
                                flat
                                class="mx-0"
                                color="primary">添加变量
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </template>
                </v-tab-item>
              </v-tabs-items>
            </template>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
    <v-flex v-if="!isReadonly" class="text-xs-right pt-2">
      <v-btn @click="submit" :loading="loading" class="mx-0" color="primary">提交</v-btn>
    </v-flex>
    <v-dialog persistent v-model="tempDialog.activate" scrollable max-width="400px">
      <l-select-template-dialog
        v-if="tempDialog.activate"
        :type="tempDialog.type"
        :raw-item="tempDialog.template"
        @cancel="closeSelectTemplateDialog"
        @save="bindTemplate($event)"
      ></l-select-template-dialog>
    </v-dialog>
  </l-layout>
</template>

<script>
import LSelectTemplateDialog from '../../../components/LSelectTemplateDialog'
import {Template, ORDER_TOKEN, Group} from '../../../object'

export default {
  name: 'violationRuleForm',
  components: {LSelectTemplateDialog},
  props: {
    rule: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    typeTab: null,
    loading: false,
    parentLoading: false,
    // 绑定分组，内容为state内，不可改动
    bindGroup: [],
    bcItems: [],
    tempDialog: {
      activate: false,
      type: 'sms',
      item: null,
      index: 0,
      template: null
    },
    typeDefines: [
      {
        key: 'sms',
        name: '短信模板'
      }
      // {
      //   key: 'wechat',
      //   name: '微信模板'
      // }
      // {
      //   key: 'email',
      //   name: '邮件模板',
      // },
    ]
  }),
  computed: {
    hasTemplate () {
      return t => t && t.id
    },
    ruleMax: {
      get () {
        return this.isRoot ? this.rule.max : this.currentRoot ? this.currentRoot.max : 0
      },
      set (val) {
        if (this.isRoot) {
          this.rule.max = val
        }
      }
    },
    ruleSeverity: {
      get () {
        return this.isRoot ? this.rule.severity : this.currentRoot ? this.currentRoot.severity : 0
      },
      set (val) {
        if (this.isRoot) {
          this.rule.severity = val
        }
      }
    },
    currentRoot () {
      return this.bcItems.length ? this.bcItems[0] : this.isRoot ? this.rule : null
    },
    groups () {
      let groups = this.$store.state.violation.groupList.slice(0)
      if (!groups.find(g => g.id === ORDER_TOKEN)) {
        groups.push(new Group({
          name: '访客',
          id: ORDER_TOKEN
        }))
      }
      return groups
    },
    isRoot () {
      return this.$route.query.parent === 'root'
    },
    isNew () {
      return this.$route.name === 'NewViolationRule'
    },
    isEdit () {
      return this.$route.name === 'EditViolationRule'
    },
    isReadonly () {
      return this.$route.name === 'ViolationRuleDetails'
    }
  },
  watch: {
    bindGroup: {
      handler (val) {
        this.formatTemplates()
        // console.log('set template', this.rule.templates)
      },
      deep: true
    },
    ruleMax () {
      this.formatTemplates()
    }
  },
  methods: {
    formatTemplates () {
      // console.log('format', this.rule.templates.sms.map(g => g.templates.map(t => t.id).join(',')))
      // 分组（不全）
      let val = this.bindGroup
      // 获取分组所有信息
      let groups = val.map(id => this.groups.find(g => g.id === id))
      this.typeDefines.forEach(type => {
        let bindTemplates = this.rule.templates[type.key] || []
        this.rule.templates[type.key] = groups.map(v => {
          let g = bindTemplates.find(b => b && v && b.id === v.id)
          if (!g) {
            g = {
              id: v && v.id,
              name: v && v.name,
              templates: []
            }
          }
          for (let i = 0; i < +this.ruleMax; ++i) {
            if (!g.templates[i]) {
              g.templates[i] = new Template()
            }
          }
          return g
        })
      })
      // console.log('format end', this.rule.templates.sms.map(g => g.templates.map(t => t.id).join(',')))
    },
    deleteVar (variantList, i) {
      variantList.splice(i, 1)
    },
    addVar (template) {
      template.variantList.push({key: '', value: ''})
    },
    getParentCode (item) {
      let codes = item.code.split('_')
      if (codes.length < 2) {
        return 'root'
      }
      else {
        return codes.slice(0, -1).join('_')
      }
    },
    async submit () {
      try {
        this.loading = true
        await this.$store.dispatch('violation/setRule', this.rule)
        this.$L.alert('success', this.isNew ? '创建成功' : '修改成功')
        this.$L.tab.close(this.$L.tab.current, false)
        this.$router.push({
          name: 'ViolationRuleManagement',
          params: {refresh: true}
        })
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.loading = false
      }
    },
    async getViolationGroups () {
      try {
        await this.$store.dispatch('violation/getGroups')
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
    },
    async getParentRules () {
      try {
        this.parentLoading = true
        this.bcItems = await this.$store.dispatch('violation/getParentRules', this.$route.query.parent)
        if (this.bcItems.length) {
          this.rule.parent = this.bcItems[this.bcItems.length - 1]
        }
        // console.log(res)
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.parentLoading = false
      }
    },
    openSelectTemplateDialog (type, item, index) {
      this.tempDialog = {
        activate: true,
        type,
        item,
        index,
        template: item.template
      }
    },
    closeSelectTemplateDialog () {
      this.tempDialog = {
        activate: false,
        type: 'sms',
        item: null,
        template: new Template()
      }
    },
    bindTemplate (template) {
      this.tempDialog.item.splice(this.tempDialog.index, 1, Template.fromAPI(template))
      this.closeSelectTemplateDialog()
    },
    deleteTemplate (templates, i) {
      templates.splice(i, 1, new Template())
    },
    initBindGroup () {
      if (this.isRoot) {
        let groups = this.rule.templates[this.typeDefines[0].key] || []
        this.bindGroup = groups.map(v => v.id)
      }
    },
    goList () {
      this.$router.push({
        name: 'ViolationRuleManagement'
      })
    },
    goDetails (item) {
      this.$router.push({
        name: 'ViolationRuleDetails',
        params: {name: item.name},
        query: {id: item.id, parent: this.getParentCode(item)}
      })
    }
  },
  created () {
    this.getViolationGroups()
    // 参数parent：编辑规则传该规则的code，添加传parent的code
    this.getParentRules()
    this.initBindGroup()
  }
}
</script>

<style scoped>

</style>
